import { UserPermissions } from '../../../definitions';
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  ISearchArgs,
  IUpdateSingleArgs
} from '../../../interfaces';
import { contentTypes, goFetch } from '../../../utilities/goFetch';
import config, { axiosInstance } from '../../../_config/global';
import { securityService } from '../../../_global/services';
let itemId = ['partner_share_by_code', 'partner_daily_report'];

const menuItems = [
  {
    _id:'partner_share_by_code', 
    name: 'Partner share by code',
    adminOnly: false,
  },
  // TODO: Disabled daily report, pending further investigation
  // {
  //   _id:'partner_daily_report', 
  //   name: 'Partner Daily Report',
  //   adminOnly: true
  // }
]

let dataInUse: any;
interface IPartnerLink {
  code: string;
  url: string;
  active?: boolean;
}

enum ELinkStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

enum ESinglePageProperties {
  ListCodes = 'listCodes',
  ListDesc = 'listDesc'
}
class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    let jsonResponse: any;

    const isAdmin = securityService.checkRoleAccess(
      UserPermissions.isSuperUser
    )
    
    const data = menuItems.filter(menuItem => menuItem.adminOnly ? isAdmin : true)
    
    if (!dataInUse) {
      jsonResponse = {
        data
      };

      dataInUse = jsonResponse.data;
    }

    return {
      pageNo: pageNo,
      pageSize: 10,
      pageCount: 1,
      data: dataInUse,
      itemCount: dataInUse.length
    };
  }

  async getSingle({ key }: IGetSingleArgs) {
    if (dataInUse) {
      let singlePage = dataInUse.filter((d: any) => d._id === key)[0];

      if (!singlePage || !singlePage._id) return;

      switch (singlePage._id) {
        case itemId[0]:
          singlePage[ESinglePageProperties.ListCodes] = [];

          const codes: IPartnerLink[] =
            await securityService.getAllUserInfluencerLinks();
          const userInfluencerCodes = securityService
            .getUserInfluencerLinks()
            .map((p: IPartnerLink) => p.code);


          const listCodes = codes
            .filter(
              (element) =>
                securityService.checkRoleAccess(UserPermissions.isSuperUser) ||
                userInfluencerCodes.find((userCode: string) => userCode.toLowerCase() === element.code?.toLowerCase())
            )
            .map((element) => ({
              label:
                element.code === element.url
                  ? `${element.code} - ${
                      element.active ? ELinkStatus.Active : ELinkStatus.Inactive
                    }`
                  : `${element.code} - ${element.url} - ${
                      element.active ? ELinkStatus.Active : ELinkStatus.Inactive
                    }`,
              _id: element.code,
              isActive: element.active
            }));

          listCodes.sort((a, b) =>
            a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1
          );

          singlePage[ESinglePageProperties.ListCodes] = listCodes;
          singlePage[ESinglePageProperties.ListDesc] = 'Codes';
      }

      return singlePage;
    }
  }

  async search({ search }: ISearchArgs) {
    return dataInUse.filter((d: any) => new RegExp(search).test(d.name));
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {}

  async delete({ key }: IDeleteSingleArgs) {}

  async getPartnerShareByCode(args: any) {
    const requestBody = {
      ...args
    };

    return goFetch(config.endpoints.reports.getPartnerShareByCode)
      .withHeaders({
        'Content-Type': contentTypes.json
      })
      .withBody({
        ...requestBody
      })
      .post()
      .then((fetchResults: any) => {
        return fetchResults.data ?? {};
      });
  }

  async getPaymentLinkByCode(args: any) {
    const requestBody = {
      ...args
    };

    return goFetch(config.endpoints.thirdParty.dots.paymentLink)
      .withHeaders({
        'Content-Type': contentTypes.json
      })
      .withBody({
        ...requestBody
      })
      .post()
      .then((fetchResults: any) => {
        return fetchResults.data;
      });
  }

  async getPendingPartnerUrls(influencer_link_code: string) {
    return goFetch(config.endpoints.thirdParty.dots.pendingUrls)
      .withHeaders({
        'Content-Type': contentTypes.json
      })
      .withQueryParameters({ influencer_link_code: influencer_link_code })
      .get()
      .then((fetchResults: any) => {
        return fetchResults?.data ?? [];
      });
  }

  async getTotalPayoutByCode(influencer_link_code: string) {
    return goFetch(config.endpoints.thirdParty.dots.totalpayouts)
      .withHeaders({
        'Content-Type': contentTypes.json
      })
      .withQueryParameters({ influencer_link_code: influencer_link_code })
      .get()
      .then((fetchResults: any) => {
        return fetchResults.data;
      });
  }

  async getUserConversionsByCode(source: string) {
    return goFetch(config.endpoints.reports.getUserConversionsByCode)
      .withHeaders({
        'Content-Type': contentTypes.json
      })
      .withQueryParameters({
        source
      })
      .get()
      .then((fetchResults: any) => {
        return fetchResults.data;
      });
  }

  async getAllPartnerRevenueShareByCode(fromDate: Date, toDate: Date) {
    const requestBody = {
      fromDate: fromDate,
      toDate: toDate
    };

    return goFetch(`${config.endpoints.reports.getAllPartnerShareByCode}`)
      .withBody({
        ...requestBody
      })
      .post()
      .then((fetchResults: any) => {
        return fetchResults;
      });
  }

  async getDailyPartnerRevenueShareByCode(fromDate: Date, toDate: Date) {
    const requestBody = {
      fromDate: fromDate,
      toDate: toDate
    };
    return axiosInstance
      .post(
        `${config.endpoints.reports.getDailyPartnerShareByCode}`,
        requestBody,
        { responseType: 'arraybuffer' }
      )
      .then((fetchResults: any) => {
        return fetchResults;
      });
  }
}

export default new Service();
